import Cookies from 'js-cookie';
export function parseAdbContextCookie(cookieName) {
    const cookieData = Cookies.get(cookieName);
    if (cookieData) {
        try {
            const value = JSON.parse(cookieData);
            return isObject(value) &&
                typeof value.key === `string` &&
                isObject(value.adbContext) &&
                typeof value.adbContext.outletId === `string` &&
                typeof value.adbContext.referrerPath === `string` &&
                typeof value.adbContext.hasCustomer === `boolean`
                ? value
                : undefined;
        }
        catch { }
    }
    return undefined;
}
function isObject(value) {
    return typeof value === `object` && value !== null;
}
//# sourceMappingURL=parse-adb-context-cookie.js.map